import CUSTOMER_LOYALTY_CONSTANTS from "../constants/CustomerLoyalty.constants";

export const setLoyaltyOrderItemPoints = (payload) => ({
  type: CUSTOMER_LOYALTY_CONSTANTS.SET_LOYALTY_ORDER_ITEM_POINTS,
  payload,
});

export default setLoyaltyOrderItemPoints;
